export default "__VITE_PUBLIC_ASSET__8fa6e640__"